module.exports = __webpack_public_path__ + "media/application/images/svgs/carrot-arrow-right-06985a01706d51f9eb5d9a4654e10f77.svg";